import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import questionProp from 'common/questionnaires/questionDataProp';
import { Style, Preconditions, DynamicUpdateAction } from 'common/questionnaires/types';
import Question from '../Question';
import QuestionCardHeader from '../QuestionCardHeader';
import CollapsibleHeader from '../CollapsibleHeader';

const QuestionCard = ({ isForm, questionsData, isLastCard, formMatched, customerRecordNameIsIndividual, legalOrSoleOwnerIsIndividual, customerRecordNameIsDRE }) => {
  const [collapsibleAreaShown, setCollapsibleAreaShown] = useState(false);
  const [cardCollapsed, setCardCollapsed] = useState(false);

  const questionsToShow = questionsData.filter((question) => {
    let showQuestion = true;

    if (formMatched && isForm && question.preconditions && question.preconditions.length) {
      if ((question.preconditions.find(p => p === Preconditions.CustomerRecordNameIsIndividual) && customerRecordNameIsIndividual)
      || (question.preconditions.find(p => p === Preconditions.LegalOrSoleOwnerIsIndividual) && legalOrSoleOwnerIsIndividual)) {
        showQuestion = false;
      } else if (question.preconditions.find(p => p === Preconditions.CustomerRecordNameIsDRE) && !customerRecordNameIsDRE) {
        showQuestion = false;
      }
    }

    if (question.dynamicUpdate && question.dynamicUpdate.conditionMet && question.dynamicUpdate.action === DynamicUpdateAction.HideAndClear) {
      showQuestion = false;
    }

    return showQuestion;
  });

  let collapsibleAreaExists = false;
  let cardHasError = false;
  if (questionsToShow && questionsToShow.length !== 0) {
    cardHasError = !!(questionsToShow.filter(q => q.hasError === true).length);

    if (cardHasError && isForm && cardCollapsed) {
      setCardCollapsed(false);
    }
    collapsibleAreaExists = !!(questionsToShow.filter(q => q.style === Style.Collapsible).length);
  }

  useEffect(() => {
    if (!isForm && isLastCard && !cardHasError && questionsToShow && questionsToShow.length && questionsToShow.length > 0 && questionsToShow[questionsToShow.length - 1]) {
      const lastCard = document.getElementById(`Q${ questionsToShow[questionsToShow.length - 1].id }`);
      if (window && lastCard && lastCard.offsetTop) {
        window.scrollTo({ top: lastCard.offsetTop - 100, behavior: 'smooth' });
      }
    }
  }, [questionsToShow.length]);

  return (
    <React.Fragment>
      {questionsToShow && questionsToShow.length !== 0 && <div id={ `Q${ questionsToShow[0].id }` } className={ `question-card${ cardHasError ? ' error' : '' }` }>
        {isForm && <QuestionCardHeader cardCollapsed={ cardCollapsed } cardHasErrorIn={ cardHasError } setCardCollapsed={ setCardCollapsed } groupName={ questionsToShow && questionsToShow[0] && questionsToShow[0].group } />}
        <div className={ `questions ${ cardCollapsed ? 'collapsed' : '' }` }>
          {questionsToShow.map((question, i) => (
            <React.Fragment key={ `Q${ question.id }` }>
              {question.collapsibleHeaderText && <CollapsibleHeader collapsibleAreaShown={ collapsibleAreaShown } setCollapsibleAreaShown={ setCollapsibleAreaShown } collapsibleHeaderText={ question.collapsibleHeaderText } />}
              {((question.style && question.style !== Style.Collapsible)
                || !collapsibleAreaExists
                || (collapsibleAreaExists && collapsibleAreaShown && question.style && question.style === Style.Collapsible))
                && <Question key={ `Q${ question.id }` } id={ question.id } isForm={ isForm } question={ question } emdedded={ i !== 0 } />}
            </React.Fragment>
          ))}
        </div>
      </div>}
    </React.Fragment>);
};

QuestionCard.propTypes = {
  isForm: PropTypes.bool,
  questionsData: PropTypes.arrayOf(questionProp).isRequired,
  isLastCard: PropTypes.bool,
  formMatched: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape({
    formType: PropTypes.string,
    formTitle: PropTypes.string
  })]),
  customerRecordNameIsIndividual: PropTypes.bool,
  legalOrSoleOwnerIsIndividual: PropTypes.bool,
  customerRecordNameIsDRE: PropTypes.bool,
};

QuestionCard.defaultProps = {
  isForm: false,
  isLastCard: false,
  formMatched: false,
  customerRecordNameIsIndividual: false,
  legalOrSoleOwnerIsIndividual: false,
  customerRecordNameIsDRE: false,
};

function mapStateToProps(state) {
  const {
    app: { onlineConfig },
    preQualifyingQuestionnaire: { derivedName, formMatched, customerRecordNameIsIndividual, legalOrSoleOwnerIsIndividual, customerRecordNameIsDRE }
  } = state;

  return {
    customerName: onlineConfig && onlineConfig.customerName,
    derivedName,
    formMatched,
    customerRecordNameIsIndividual,
    legalOrSoleOwnerIsIndividual,
    customerRecordNameIsDRE
  };
}

export default connect(mapStateToProps)(QuestionCard);
